import { IconPropsType } from '..';

export const RequestedIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4665_30704)">
      <path d="M6.85232 0.599854L6.0001 1.45207L6.42621 1.87622L5.00552 3.29985L5.53864 5.5384L3.3001 5.00527L1.87646 6.42596L1.45232 5.99985L0.600098 6.85207L5.14788 11.3999L6.0001 10.5476L5.57399 10.1235L6.99468 8.69985L6.46155 6.46131L8.7001 6.99443L10.1237 5.57374L10.5479 5.99985L11.4001 5.14763L6.85232 0.599854ZM5.14788 9.69444L4.72373 9.26833L4.70802 9.25262L5.53079 8.42985L5.15377 6.84913L3.57304 6.47211L2.75028 7.29487L2.73162 7.27622L2.30552 6.84913L3.48861 5.67094L5.7841 6.21585L6.32999 8.51134L5.14788 9.69444ZM8.51159 6.32974L6.2161 5.78385L5.67021 3.48836L6.84839 2.31018L9.69075 5.15745L8.51159 6.32974Z" />
    </g>
    <defs>
      <clipPath id="clip0_4665_30704">
        <rect
          width="12"
          height="12"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
